<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="title"></a>EMERALD<br/>WINDOWS</h1>
<p class="bkauthor">Terri Blackstock</p>
<p class="publisher"><img alt="image" class="img-mid" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004titlepage.vue?f0686d32